export const LOADING_NOTIFICATION_VARIABLE = "LOADING_NOTIFICATION_VARIABLE";
export const GET_NOTIFICATION_VARIABLE = "GET_NOTIFICATION_VARIABLE";
export const NOTIFICATION_VARIABLE_FAIL = "NOTIFICATION_VARIABLE_FAIL";
